import React from 'react';
import PropTypes from 'prop-types';

const CloseOval = ({ color = '#B5BDC5' }) => (
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g
            id="Svg-Icons/18px-(All-icons)/UI/close_oval"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g id="UI_field_clear">
                <rect
                    id="Rectangle"
                    stroke="#979797"
                    fill="#D8D8D8"
                    opacity="0"
                    x="0.5"
                    y="0.5"
                    width="17"
                    height="17"
                />
                <path
                    d="M18.0000001,9 C18.0098,4.04651041 13.9881516,0.00942732057 9.00000006,0 C4.04695656,-0.00979969881 0.00983501222,4.01176085 0,9 C-0.00939261184,13.9532554 4.0119573,17.9901654 9.00000006,18 C13.9537016,18.0093928 17.9905732,13.9879551 18.0000001,9 L18.0000001,9 Z"
                    id="Plus-Circle-64px"
                    fill="#FAFBFC"
                    fillRule="nonzero"
                />
                <g
                    id="Svg-Icons/10px-(All-icons)/no-scale/close-10px"
                    transform="translate(4.000000, 4.000000)"
                    fill={color}
                >
                    <path
                        d="M5,4.29289322 L8.24644661,1.04644661 C8.44170876,0.851184464 8.75829124,0.851184464 8.95355339,1.04644661 C9.14881554,1.24170876 9.14881554,1.55829124 8.95355339,1.75355339 L5.70710678,5 L8.95355339,8.24644661 C9.14881554,8.44170876 9.14881554,8.75829124 8.95355339,8.95355339 C8.75829124,9.14881554 8.44170876,9.14881554 8.24644661,8.95355339 L5,5.70710678 L1.75355339,8.95355339 C1.55829124,9.14881554 1.24170876,9.14881554 1.04644661,8.95355339 C0.851184464,8.75829124 0.851184464,8.44170876 1.04644661,8.24644661 L4.29289322,5 L1.04644661,1.75355339 C0.851184464,1.55829124 0.851184464,1.24170876 1.04644661,1.04644661 C1.24170876,0.851184464 1.55829124,0.851184464 1.75355339,1.04644661 L5,4.29289322 Z"
                        id="icon-Close-Oval"
                    />
                </g>
            </g>
        </g>
    </svg>
);

CloseOval.propTypes = {
    color: PropTypes.string,
};

export default CloseOval;
